export const fireTeamData = [
  {
    label: 'FIRE TEAM',
    description: {
      label: 'ROLE DESCRIPTION',
      desc: 'Members of the Fire Team responsible for various tasks related to escape plans.',
    },
    tasks: {
      label: 'Tasks',
      task1: 'Review the entire escape plan.',
      task2: 'Submission of Escape Plan for Client Review.',
      task3: 'Send notification to the client after reviewing the escape plan.',
    },
  },
];
export const draftsManData = [
  {
    label: 'DRAFTSMAN',
    description: {
      label: 'ROLE DESCRIPTION',
      desc: 'Responsible for creating and drafting escape plans.',
    },
    tasks: {
      label: 'Tasks',
      task1: 'Draw an Escape Plan for the client.',
      task2:
        "Drawing uploaded and marked 'draft complete and in review by fire engineer.'",
      task3: 'Send notification to the client after reviewing the escape plan.',
    },
  },
];

export const taskDetailsData = [
  {
    label: 'TASK DETAILS',
    tags: [
      {
        label: 'Review the entire escape plan',
        Role: 'Fire Team',
        desc: 'Members of the Fire Team are tasked with reviewing the entire escape plan.',
      },
      {
        label: 'Submission of Escape Plan for Client Review',
        Role: 'Fire Team',
        desc: 'Fire Team members are responsible for submitting the escape plan for client review.',
      },
      {
        label: 'Send notification to the client after reviewing escape plan',
        Role: 'Fire Team',
        desc: 'Fire Team members are required to notify the client after reviewing the escape plan.',
      },
      {
        label: 'Draw an Escape Plan for the client',
        Role: 'Draftsman',
        desc: 'The Draftsman is responsible for drawing an escape plan for the client.',
      },
      {
        label:
          "Drawing uploaded and marked 'draft complete and in review by fire engineer'",
        Role: 'Draftsman',
        desc: "After completing the draft, the Draftsman uploads the drawing and marks it as 'draft complete and in review by fire engineer.'",
      },
      {
        label: 'Send notification to the client after reviewing escape plan',
        Role: 'Draftsman',
        desc: ' The Draftsman notifies the client after the escape plan has been reviewed.',
      },
    ],
  },
];
